import request from '@/utils/request'

// 分页查询合同信息
export function getPageList(params) {
  return request({
    url: '/hrApi/rentContract',
    method: 'get',
    params: params
  })
}

// 获取合同列表
export function getList(params) {
  return request({
    url: '/hrApi/rentContract/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑合同
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/rentContract',
    method: 'post',
    data: data
  })
}

// 删除合同
export function deleteData(id) {
  return request({
    url: '/hrApi/rentContract/' + id,
    method: 'delete'
  })
}

// 获取详情
export function getInfo(id) {
  return request({
    url: '/hrApi/rentContract/info/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/rentContract.js